<template>
  <v-dialog v-model="showDialog" width="800px">
    <v-overlay :value="isLoading">
      <v-progress-circular
        indeterminate
        color="primary"
        :size="70"
        :width="7"
      ></v-progress-circular>
    </v-overlay>
    <v-card class="search-modal">
      <h2 class="mb-3">Search & Add Kennels</h2>
      <v-form @submit.prevent="search">
        <v-row>
          <v-col>
            <v-text-field
              outlined
              v-model="kennelId"
              label="Kennel ID"
            />
          </v-col>
          <v-col>
            <v-text-field
              outlined
              v-model="kennelName"
              label="Kennel Name"
            />
          </v-col>
          <v-col>
            <v-btn v-on:click="search" color="primary">
              <v-icon> mdi-magnify </v-icon>
              Search
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
      <p v-if="!isLoading">
        <span v-if="!!searchResults && !searchResults.length && hasSearched">
          No kennels found
        </span>
        <span v-else>
          Found {{ searchResults.length }} matching record(s)
        </span>      
      </p>
      <v-data-table
        v-if="!!searchResults && searchResults.length"
        :headers="headers"
        :items="searchResults"
        :items-per-page="searchResults.length"
        hide-default-header
        hide-default-footer
      >
        <template v-slot:item="row">
          <tr>
              <td>
                  <a :href="`/admin/kennels/${row.item.kennelId}`" target="_blank">
                    {{ row.item.kennelId }}
                  </a>
                </td>
                <td>
                  <a :href="`/admin/kennels/${row.item.kennelId}`" target="_blank">
                    {{ row.item.name }}
                  </a>
                </td>  
              <td>
                <td>
                  <a v-on:click="addKennel(row.item)">
                    <font-awesome-icon
                      icon="plus"
                      :color="blue"
                    />
                  </a>
                </td>
              </tr>
        </template>
      </v-data-table>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import Vue from "vue";
import kennelService from "@/services/admin/kennelService";

export default Vue.extend({
  name: "AdminKennelSearchDialogOld",
  data: function () {
    return {
      showDialog: this.$props.kennelSearchDialog,
      hasSearched: false,
      searchResults: [] as any[],    
      kennelName: "",
      kennelId: "",
      headers: [
        { text: "ID", align: "left", value: "kennelId" },
        { text: "Name", align: "left", value: "name" },
      ],
      isLoading: false,
    };
  },
  watch: {
    kennelSearchDialog: function (newVal: boolean) {
      if (!newVal) {
        this.kennelName = "";
        this.kennelId = "";
        this.hasSearched = false;
        this.searchResults = [];
      }
      this.showDialog = newVal;
    },
  },
  methods: {
    search: function () {
      this.isLoading = true;
      this.hasSearched = false;
      kennelService
        .adminSearchKennels({
          kennelId: this.kennelId,
          name: this.kennelName, 
          page: 0
        })
        .then((response: any) => {
            //todo: cleanup once we confirm this is the desired design of this component, 
            //either create dedicated API action for simple search
            //or extend current search to allow selecting all records
            kennelService
                .adminSearchKennels({
                    kennelId: this.kennelId,
                    name: this.kennelName, 
                    pageSize: response.totalCount,
                    page: 0
                })
                .then((response: any) => {
                    this.searchResults = response.data;
                    this.isLoading = false;
                    this.hasSearched = true;
                });
        });
    },
    addKennel(row: any) {
      this.$emit("kennelAdded", { kennel: row });
      this.showDialog = false;
    },
  },
  props: {
    kennelSearchDialog: Boolean,
  },
});
</script>